import * as yup from 'yup';


export const basicSchema = yup.object().shape({
    name: yup.string().required('Name is required'),
    email: yup.string().email().required('Email is required'),
    contact: yup.number().required('Contact is required'),
    content: yup.string().required('Content is required'),
    budget_range_id: yup.number().required('Please Select Budget Range'),
    project_summary: yup.string().required('Project Summary is required').min(100, 'Project Summary must be at least 100 characters'),
    news_latter: yup.string(),
});

export const reviewSchema = yup.object().shape({
    overall_satisfaction: yup.string().required('Overall Satisfaction is required'),
    communication: yup.string().required('Communication is required'),
    quality_work: yup.string().required('Quality Work is required'),
    timeliness: yup.string().required('Timeliness medium is required'),
    value_for_money: yup.string().required('Value for money is required'),
    recommendation: yup.string().required('Recommendation is required'),
    work_with_us: yup.string().required('Work with us is required'),
    should_improved: yup.string().required('Should Improved  is required'),
    additional_comments: yup.string(),
});